import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StatutCommande } from '@core/models/statut-commande.model';

@Component({
  selector: 'app-suivi-campagne-caroussel',
  templateUrl: './suivi-campagne-caroussel.component.html',
  styleUrls: ['./suivi-campagne-caroussel.component.scss']
})
export class SuiviCampagneCarousselComponent implements OnInit, OnChanges {

  @Input() statuts: StatutCommande[] = [];

  public items: StatutCommande[] = [];
  public currentStatutCommandeArray: StatutCommande[] = [];
  public maxRecord = 12;
  public slidesize = 3;
  public cs = -1 * this.slidesize;
  public previtems: StatutCommande[] = [];

  constructor() { }

  ngOnInit(): void {
    this.rebuildCarousel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statuts']) {
      this.rebuildCarousel();
    }
  }

  private rebuildCarousel(): void {
    const source = Array.isArray(this.statuts) ? [...this.statuts] : [];
    this.currentStatutCommandeArray = source;

    if (this.currentStatutCommandeArray.length >= 1) {
      this.currentStatutCommandeArray = this.currentStatutCommandeArray.map((sc, index, arr) => ({
        ...sc,
        Title: index === arr.length - 1 ? 'En cours' : 'Terminé'
      }));

      this.currentStatutCommandeArray.push({
        idCommande: '',
        idStatutCommande: '',
        IdStatut: '',
        creeParLogin: '',
        modifieParLogin: '',
        dateCreation: 'A venir',
        dateModification: 'A venir',
        codeStatut: '',
        Statut: '',
        StatutLibelle: 'A venir',
        Title: 'A venir'
      } as StatutCommande);
    }

    this.items = [];
    this.previtems = [];
    this.cs = -1 * this.slidesize;
    this.maxRecord = this.currentStatutCommandeArray.length;

    if (this.maxRecord <= this.slidesize) {
      this.items = this.currentStatutCommandeArray;
      return;
    }

    this.initCarousel(this.slidesize);
  }

  initCarousel(size: number): void {
    let arr = this.nextSet(size);
    this.previtems = this.nextSet(size);
    arr = arr.concat(this.previtems);

    if (arr.length > 0) {
      this.items = arr;
    }
  }

  nextSet(size: number): StatutCommande[] {
    let arr: StatutCommande[] = [];
    let start = 0;
    let end = 0;

    start = this.cs = (this.cs + size) % this.maxRecord;
    end = this.cs + size;

    arr = this.currentStatutCommandeArray.slice(start, end);

    if (arr.length < size) {
      arr = arr.concat(this.currentStatutCommandeArray.slice(0, size - arr.length));
    }

    return arr;
  }

  previousSet(size: number): StatutCommande[] {
    let arr: StatutCommande[] = [];
    let start = 0;
    let end = 0;

    if (this.cs - size < 0) {
      this.cs = size;
    }

    start = this.cs = (this.cs - size) % this.maxRecord;
    end = this.cs + size;
    arr = this.currentStatutCommandeArray.slice(start, end);

    return arr;
  }

  fetch(event: any): void {
    if (event === 'prev') {
      const currentRecordSet = this.previousSet(this.slidesize);

      if (currentRecordSet.length > 0) {
        if (this.cs === -1 * this.slidesize) {
          this.items = currentRecordSet;
        } else {
          this.items = currentRecordSet.concat(this.previtems);
          this.previtems = currentRecordSet;
        }
      }
    } else if (event === 'next') {
      if (this.cs === -1 * this.slidesize) {
        this.initCarousel(this.slidesize);
      }

      const currentRecordSet = this.nextSet(this.slidesize);

      if (currentRecordSet.length > 0) {
        this.items = this.previtems.concat(currentRecordSet);
        this.previtems = currentRecordSet;
      }
    }
  }
}